// Web app, Common module.
//

// Everpolate.
import { linear } from 'everpolate'

// Blood pressure, categories and stages.
// https://pediatrics.aappublications.org/content/140/3/e20171904 (Table 3).
//
export const calculateSAHStage = (sex, age, height, sbp, dbp, tabs) => {
    const resp = { stages: { } }
    const memo = { stages: { } }

    memo.tab = tabs[sex == 'Masculino' ? 0 : 1]

    memo.stages[0] = 'PA abaixo do "Normal"'
    memo.stages[1] = 'Normal'
    memo.stages[2] = 'Normal - Elevada'
    memo.stages[3] = 'Elevada'
    memo.stages[4] = 'Estágio 1 de Hipertensão'
    memo.stages[5] = 'Estágio 2 de Hipertensão'

    // Adjusting the given height over the sampled ones.
    for (let i = 0; i < 6; i++) {
        const h = memo.tab.meta.heights[age]

        if (h[i + 1] >= height && height >= h[i]) {
            const mid = h[i] + ((h[i + 1] - h[i]) / 2)

            memo.hp = height > mid ? h[i + 1] : h[i]

            break

        } else if (i == 0 && h[i] > height) {
            memo.hp = h[i]

            break

        } else if (i == 5 && height > h[i + 1]) {
            memo.hp = h[i + 1]

            break
        }
    }

    memo['sbp 50th'] = memo.tab.meta.sbp[age][memo.hp]['50th']
    memo['sbp 90th'] = memo.tab.meta.sbp[age][memo.hp]['90th']
    memo['sbp 95th'] = memo.tab.meta.sbp[age][memo.hp]['95th']
    memo['sbp 95th + 12 mm Hg'] = memo.tab.meta.sbp[age][memo.hp]['95th + 12 mm Hg']

    memo['dbp 50th'] = memo.tab.meta.dbp[age][memo.hp]['50th']
    memo['dbp 90th'] = memo.tab.meta.dbp[age][memo.hp]['90th']
    memo['dbp 95th'] = memo.tab.meta.dbp[age][memo.hp]['95th']
    memo['dbp 95th + 12 mm Hg'] = memo.tab.meta.dbp[age][memo.hp]['95th + 12 mm Hg']

    // Finding blood pressure percentiles.
    const params = { sbp: { x: [ ], y: [ ] }, dbp: { x: [ ], y: [ ] } }

    params.sbp.x.push(1)
    params.sbp.x.push(memo['sbp 50th'])
    params.sbp.x.push(memo['sbp 90th'])
    params.sbp.x.push(memo['sbp 95th'])
    params.sbp.x.push(memo['sbp 95th + 12 mm Hg'])

    params.sbp.y.push(1)
    params.sbp.y.push(50)
    params.sbp.y.push(90)
    params.sbp.y.push(95)
    params.sbp.y.push(107)

    params.dbp.x.push(1)
    params.dbp.x.push(memo['dbp 50th'])
    params.dbp.x.push(memo['dbp 90th'])
    params.dbp.x.push(memo['dbp 95th'])
    params.dbp.x.push(memo['dbp 95th + 12 mm Hg'])

    params.dbp.y.push(1)
    params.dbp.y.push(50)
    params.dbp.y.push(90)
    params.dbp.y.push(95)
    params.dbp.y.push(107)

    resp.sp = linear(sbp, params.sbp.x, params.sbp.y)
    resp.dp = linear(dbp, params.dbp.x, params.dbp.y)

    // Finding blood pressure hypertension stages.
    if (age < 13) {
        const stages = [0, 0]

        // Evaluating of systolic blood pressure.
        if (sbp < memo['sbp 50th']) {
            stages[0] = 0

        } else if (sbp < memo['sbp 90th'] && memo['sbp 50th'] <= sbp) {
            stages[0] = 1

        } else if ((sbp < memo['sbp 95th'] && memo['sbp 90th'] <= sbp) || (sbp < memo['sbp 95th'] && 120 <= sbp)) {
            stages[0] = 3

        } else if ((sbp < memo['sbp 95th + 12 mm Hg'] && memo['sbp 95th'] <= sbp) || (sbp < 140 && 130 <= sbp)) {
            stages[0] = 4

        } else if (memo['sbp 95th + 12 mm Hg'] <= sbp || 140 <= sbp) {
            stages[0] = 5
        }

        // Evaluating of diastolic blood pressure.
        if (dbp < memo['dbp 50th']) {
            stages[1] = 0

        } else if (dbp < memo['dbp 90th'] && memo['dbp 50th'] <= dbp) {
            stages[1] = 1

        } else if ((dbp < memo['dbp 95th'] && memo['dbp 90th'] <= dbp) || (dbp < memo['dbp 95th'] && 80 <= dbp)) {
            stages[1] = 3

        } else if ((dbp < memo['dbp 95th + 12 mm Hg'] && memo['dbp 95th'] <= dbp) || (dbp < 90 && 80 <= dbp)) {
            stages[1] = 4

        } else if (memo['dbp 95th + 12 mm Hg'] <= dbp || 90 <= dbp) {
            stages[1] = 5
        }

        // The result must be the highest elevated level between systolic and diastolic.
        // resp.stage = memo.stages[Math.max(...stages)]

        resp.stages.s = memo.stages[stages[0]]
        resp.stages.d = memo.stages[stages[1]]

    } else { // age >= 13.
        const stages = [0, 0]

        // Evaluating of systolic blood pressure.
        if (resp.sp < 50) {
            stages[0] = 0

        } else if (sbp < 120) {
            stages[0] = 1

        } else if (sbp < 130 && 120 <= sbp) {
            stages[0] = 3

        } else if (sbp < 140 && 130 <= sbp) {
            stages[0] = 4

        } else if (140 <= sbp) {
            stages[0] = 5
        }

        // Evaluating of diastolic blood pressure.
        if (resp.dp < 50) {
            stages[1] = 0

        } else if (dbp < 80) {
            stages[1] = 2

        } else if (dbp < 90 && 80 <= dbp) {
            stages[1] = 4

        } else if (90 <= dbp) {
            stages[1] = 5
        }

        resp.stages.s = memo.stages[stages[0]]
        resp.stages.d = memo.stages[stages[1]]
    }

    return resp
}

export const round2int = n => {
    if (typeof n == 'number')
        return Math.round(n)

    return n
}

export const round2dec = n => {
    if (typeof n == 'number')
        return Math.round(n * 100) / 100 // parseFloat(n.toFixed(2))

    return n
}
